

















































import { Component, Vue } from 'vue-property-decorator';
import TextField from '@/components/form/TextField.vue';
import { ValidationError } from 'class-validator';
import Feedback from '@/types/feedback/Feedback';
import { FeedbackCategory } from '@/types/feedback/FeedbackCategory';
import Select from '@/components/form/Select.vue';
import SelectField from '@/components/form/SelectField.vue';
import TextArea from '@/components/form/TextArea.vue';
import Button from '@/components/Button.vue';
import i18next from 'i18next';
import CommonApi from '@/app/api/CommonApi';
import { State } from 'vuex-class';
import getFeedbackTranslationKey from '@/views/feedback/utils/getFeedbackTranslationKey';

@Component({
  components: {
    Button,
    TextArea,
    SelectField,
    Select,
    TextField,
  },
})
export default class FeedbackContent extends Vue {
  public errors: ValidationError[] = [];
  public feedbackFormular: Feedback = new Feedback();

  @State
  public communeSelected!: number;

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.errors.splice(index, 1);
  }

  public get feedbackCategories() {
    const categories = [
      null,
      FeedbackCategory.TOURISMNFEE,
      FeedbackCategory.BENEFITS,
      FeedbackCategory.COMMUNE,
      FeedbackCategory.ERROR,
      FeedbackCategory.SUGGESTION,
    ];
    return categories.map(cat => ({ value: cat, label: i18next.t(getFeedbackTranslationKey(cat)) }));
  }

  public async sendFeedback() {
    this.errors = this.feedbackFormular.validate();
    if (this.errors.length > 0) {
      console.log(this.errors);
      return;
    }

    try {
      await CommonApi.sendUserFeedback(this.communeSelected, this.feedbackFormular.getJSONData());
      await this.showDialog('feedbackFormular.request.success.title', 'feedbackFormular.request.success.message');

      this.feedbackFormular = new Feedback();
    } catch (error) {
      this.showDialog('feedbackFormular.request.error.title', error);
    }
  }

  private async showDialog(title: string, message: string) {
    await this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title: i18next.t(title),
        message: i18next.t(message),
      },
    });
  }
}
